import React from "react";
import { Alert } from "reactstrap";

interface AssignmentAlertProps {
  currentEstablishment: string | null;
  currentPoint: string | null;
  establishments: any[];
  onAddEstablishment: () => void;
  onSelectEstForPoints: (establishment: any) => void;
}

const AssignmentAlert: React.FC<AssignmentAlertProps> = ({
  currentEstablishment,
  currentPoint,
}) => {
  const hasEstablishment = !!currentEstablishment;
  const hasPoint = !!currentPoint;

  if (!hasEstablishment && !hasPoint) {
    return (
      <Alert color="warning" className="mb-3">
        <div className="d-flex align-items-center">
          <i className="ri-error-warning-line me-2 fs-4"></i>
          <div className="flex-grow-1">
            <h6 className="alert-heading mb-1">No tienes establecimientos ni puntos de emisión asignados</h6>
            <p className="mb-2">Debes asignar un establecimiento y un punto de emisión para continuar.</p>
          </div>
        </div>
      </Alert>
    );
  }

  if (!hasEstablishment) {
    return (
      <Alert color="warning" className="mb-3">
        <div className="d-flex align-items-center">
          <i className="ri-error-warning-line me-2 fs-4"></i>
          <div className="flex-grow-1">
            <h6 className="alert-heading mb-1">No tienes un establecimiento asignado</h6>
            <p className="mb-2">Debes configurar un establecimiento para continuar.</p>
          </div>
        </div>
      </Alert>
    );
  }

  if (!hasPoint) {
    return (
      <Alert color="warning" className="mb-3">
        <div className="d-flex align-items-center">
          <i className="ri-error-warning-line me-2 fs-4"></i>
          <div className="flex-grow-1">
            <h6 className="alert-heading mb-1">No tienes un punto de emisión asignado</h6>
            <p className="mb-2">Debes configurar un punto de emisión para continuar.</p>
          </div>
        </div>
      </Alert>
    );
  }

  return null;
};

export default AssignmentAlert;
